import { type FC, useState } from "react";
import { ContextMenu } from "@packsize/components";

import { type ClosingCarton } from "@/schemas/routing/closing-carton";

import { ManuallyCloseMenuItem } from "../action-menu/manually-close-menu-item";
import { RemoveClosingMenuItem } from "../action-menu/remove-closing-menu-item";
import { SeeDetailsMenuItem } from "../action-menu/see-details-menu-item";
import { RemoveClosingModal } from "../action-menu/remove-closing-modal";

interface AwaitingClosingActionMenuProps {
	readonly closingCarton: ClosingCarton;
}

export const AwaitingClosingActionMenu: FC<AwaitingClosingActionMenuProps> = ({ closingCarton }) => {
	const { packagingSolutionId, closingId, alias } = closingCarton;
	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

	return (
		<>
			<ContextMenu
				popoverProps={{
					anchorOrigin: {
						vertical: "bottom",
						horizontal: "center",
					},
					transformOrigin: {
						vertical: "top",
						horizontal: "right",
					},
				}}
			>
				<ManuallyCloseMenuItem internalUniqueId={packagingSolutionId} closingId={closingId} />
				<RemoveClosingMenuItem setIsOpen={setIsRemoveModalOpen} />
				<SeeDetailsMenuItem internalUniqueId={packagingSolutionId} />
			</ContextMenu>
			<RemoveClosingModal
				internalUniqueId={packagingSolutionId}
				closingId={closingId}
				alias={alias}
				setIsOpen={setIsRemoveModalOpen}
				isOpen={isRemoveModalOpen}
			/>
		</>
	);
};
